import React from "react";
import { Label, Row, Col, Form } from "reactstrap";

const Servicios = () => {
  return (
    <React.Fragment>
      <Form>
        <div className="mb-2">
          <Label>Servicios Disponibles :</Label>
          <Row>
            <Col xl={2} sm={4}>
              <div className="mb-3">
                <label className="card-radio-label mb-2">
                  <input
                    type="radio"
                    name="currency"
                    id="buycurrencyoption1"
                    className="card-radio-input"
                    defaultChecked
                    readOnly
                  />
                  <div className="card-radio">
                    <div>
                      <i className="mdi mdi-bitcoin font-size-24 text-warning align-middle me-2" />
                      <span> Agua</span>
                    </div>
                  </div>
                </label>
                <div>
                  <p className="text-muted mb-1"> Current price :</p>
                  <h5 className="font-size-16"> $16</h5>
                </div>
              </div>
            </Col>

            <Col xl={2} sm={4}>
              <div className="mb-3">
                <label className="card-radio-label mb-2">
                  <input
                    type="radio"
                    name="currency"
                    id="buycurrencyoption2"
                    className="card-radio-input"
                  />
                  <div className="card-radio">
                    <div>
                      <i className="mdi mdi-ethereum font-size-24 text-primary align-middle me-2" />
                      <span> Luz</span>
                    </div>
                  </div>
                </label>
                <div>
                  <p className="text-muted mb-1">Current price : </p>
                  <h5 className="font-size-16">$73</h5>
                </div>
              </div>
            </Col>

            <Col xl={2} sm={4}>
              <div className="mb-3">
                <label className="card-radio-label mb-2">
                  <input
                    type="radio"
                    name="currency"
                    id="buycurrencyoption3"
                    className="card-radio-input"
                  />
                  <div className="card-radio">
                    <div>
                      <i className="mdi mdi-litecoin font-size-24 text-info align-middle me-2" />
                      <span> Colegio</span>
                    </div>
                  </div>
                </label>
                <div>
                  <p className="text-muted mb-1"> Current price : </p>
                  <h5 className="font-size-16">$25 </h5>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Form>
    </React.Fragment>
  );
};

export { Servicios };
